import React from 'react'
import styled from 'styled-components'
import MediaList from 'components/partials/MediaList'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import ViewModeContext from 'contexts/ViewModeContext'
import useClickLogger from 'api/ClickLogger'
import { useTranslation } from 'react-i18next'

function ProgrammePageTemplate({ ...doc }) {

  return (
    <ViewModeContext.Consumer>
      {context => context.isTable ? (
        <Table {...doc} />
      ) : (
        <Teaser {...doc} />
      )}
    </ViewModeContext.Consumer>
  )
}

export default ProgrammePageTemplate

function Table({
  title,
  organization_type,
  url,
  _click,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  const { t } = useTranslation();
  return (
    <tr onClick={trackResultClick} className="u-cursor-pointer">
      <td>
        <div className="media">
          <MediaContent>
            <Link href={url}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <IconArrowRight />
            </Link>
          </MediaContent>
        </div>
      </td>
      <td>
        <Description text={t(organization_type)} />
      </td>
    </tr>
  )
}

const TableRow = styled.div`
  display: table-row;
`
const TableCell = styled.div`
  display: table-cell;
  padding-right: 16px;
`

function Teaser({
  title,
  organization_type,
  url,
  _click,
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);

  return (
    <MediaList onClick={trackResultClick}>
      <MediaContent>
        <Link href={url}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
          <IconArrowRight />
        </Link>
        <div className="u-mt-25">
          <TableRow>
            <TableCell className="description u-text-color-secondary u-text-lowercase u-text-first-uppercase u-font-weight-700">
              {organization_type}
            </TableCell>
          </TableRow>
        </div>
        <Breadcrumb links={__breadcrumb__} modifierClasses="u-mt-50" disabled />
      </MediaContent>
    </MediaList>
    
  )
}
